import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const BRANDS = [
  { key: "qj", to: "/qj-motor", logo: "/qj/qjmotor-logo.png", logoCls: "h-6 md:h-7 max-w-[300px]", img: "/qj/srk800rr-5.webp", alt: "QJ MOTOR SRK 800 RR", tag: "Motoren", cta: "Ontdek QJ Motor" },
  { key: "santini", to: "/santini", logo: "/santini/santini-logo.png", logoCls: "h-14 md:h-[72px]", img: "/santini/bnardo-1.jpg", imgCls: "object-[center_30%]", alt: "Santini Capri scooter", tag: "Scooters", cta: "Ontdek Santini" },
];

export default function BrandsSection() {
  return (
    <section data-testid="home-brands" className="section-pad bg-[#0A0A0B]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-10 h-[3px] bg-[#E10600]" />
          <span className="font-mono-tt uppercase text-xs tracking-[0.3em] text-[#E10600]">Officieel aanbod</span>
        </div>
        <h2 data-testid="home-brands-title" className="heading-xl text-4xl md:text-6xl text-white mb-10 md:mb-14">Ontdek onze merken</h2>
        <div className="grid md:grid-cols-2 gap-5 md:gap-7">
          {BRANDS.map((b, i) => (
            <motion.div key={b.key} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ delay: i * 0.1, duration: 0.5 }}>
              <Link to={b.to} data-testid={`home-brand-${b.key}`}
                className="group relative block aspect-[4/5] sm:aspect-[4/3] md:aspect-[5/6] lg:aspect-[4/3] overflow-hidden border border-[#2A2B31] hover:border-[#5A5C63] bg-black transition-colors">
                <img src={b.img} alt={b.alt} loading="lazy" className={`absolute inset-0 w-full h-full object-cover ${b.imgCls || ""} transition-transform duration-[900ms] group-hover:scale-105`} />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] from-10% via-[#0A0A0B]/70 via-40% to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-10 flex flex-col items-start">
                  <span className="font-mono-tt text-[10px] uppercase tracking-[0.3em] text-white/70 mb-4">{b.tag}</span>
                  <img src={b.logo} alt={b.cta.replace("Ontdek ", "")} data-testid={`home-brand-logo-${b.key}`} className={`${b.logoCls} w-auto max-w-[80%] mb-6 md:mb-8`} />
                  <span data-testid={`home-brand-cta-${b.key}`}
                    className="inline-flex items-center gap-2 bg-[#E10600] group-hover:bg-white text-white group-hover:text-[#0A0A0B] font-display uppercase font-700 tracking-wide text-sm px-6 py-4 transition-colors">
                    {b.cta} <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
